import React, { useEffect, useState } from 'react'
import { Drawer, IconButton, Box, Typography, useTheme, Collapse, SwipeableDrawer } from '@mui/material'
import { ALIVE_SUPPORT_URL, ERPDashboardPageURL, Icons } from '../../../utils/utilities'
import { Link } from 'react-router-dom'
import { useLayoutContext } from '../../../contexts/layout.context'
import aliveLogo from '../../../assets/alivelogo.png'

const closedSidebarWidth = 60

const getCodingLabsLink = () => {
    const prod = true
    const baseUrl = prod ? `https://codelabs.alive.university` : `http://localhost:5173`

    if ( sessionStorage.getItem( "impersonation_id_token" ) )
        return `${baseUrl}/sso?token=${sessionStorage.getItem( "impersonation_id_token" )}`
    return `${baseUrl}/sso?token=${localStorage.getItem( 'id_token' )}`
}

const menu = [
    { id: "menuitem-home", view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/student\/home)\/?$/], label: "Home", children: null, link: `/student/home`, icon: Icons.default.HomeIconOutlined, activeIcon: Icons.default.HomeIcon },
    // { id: "menuitem-subjects", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/student\/subjects)\/?$/, /^(\/student\/subject\/\d+)\/?$/, /^(\/student\/subject\/\d+\/\w+)\/?$/], label: "Subjects", children: null, link: `/student/subjects`, icon: Icons.default.SubjectsOutlined, activeIcon: Icons.default.Subjects },
    { id: "menuitem-materials", view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/student\/material)\/?$/, /^(\/student\/material\/\d+)\/?$/], label: "Study Materials", children: null, link: `/student/material`, icon: Icons.default.DescriptionIconOutlined, activeIcon: Icons.default.DescriptionIcon },
    { id: 'menuitem-class-resources', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/student\/class-sessions)\/?$/, /^(\/student\/class-sessions\/\d+)\/?$/], permission: true, label: "Beyond Class Resources", children: null, link: `/student/class-sessions`, icon: Icons.default.ClassOutlined, activeIcon: Icons.default.Class },
    { id: "menuitem-assignments", view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/student\/assignment)\/?$/, /^(\/student\/assignment\/\d+)\/?$/], label: "Assignments", children: null, link: `/student/assignment`, icon: Icons.default.AssignmentIconOutlined, activeIcon: Icons.default.AssignmentIcon },
    { id: "menuitem-exams", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/student\/exams)\/?$/, /^(\/student\/exams\/\d+)\/?$/, /^(\/student\/scores)\/?$/, /^(\/student\/scores\/\d+\/\d+)\/?$/, /^(\/student\/exams\/\d+\/attempt\/\d+\/\d+)\/?$/], label: "Exams", children: null, link: "/student/exams", activeIcon: Icons.default.QuizIcon, icon: Icons.default.QuizIconOutlined },
    { id: 'menuitem-hybrid-classes', view: ["left-panel", "opened-bottom-bar"], headerText: "Hybrid Classes", activeMatchRegexes: [/^(\/student\/hybrid-classes)\/?$/, /^(\/student\/hybrid-class\/[\w-]+)\/?$/], permission: true, label: "Hybrid Classes", children: null, link: "/student/hybrid-classes", activeIcon: Icons.default.HybridClasses, icon: Icons.default.HybridClassesOutlined },
    { id: "menuitem-discussions", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/student\/discussions)\/?$/, /^(\/student\/discussion\/\w+)\/?$/, /^(\/student\/my-discussions)\/?$/, /^(\/student\/my-discussions\/\w+)\/?$/], permission: true, label: "Discussions", children: null, link: "/student/discussions", childrenIcons: [{ default: Icons.default.QuestionMarkOutlined, activeIcon: Icons.default.QuestionMark }, { default: Icons.default.BadgeOutlined, activeIcon: Icons.default.Badge }], activeIcon: Icons.default.Discussions, icon: Icons.default.DiscussionsOutlined },
    { id: "menuitem-codelabs", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [], secondaryIcon: Icons.default.OpenInNewIcon, target: "_blank", label: "Coding labs", new: true, children: null, link: getCodingLabsLink, activeIcon: Icons.default.CodeLab, icon: Icons.default.CodeLab },
    { id: "menuitem-resumebuilder", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/student\/resume-builder)\/?$/, /^(\/student\/resume-builder\/preview)\/?$/], label: "Resume Builder", children: null, link: "/student/resume-builder", activeIcon: Icons.default.Protrait, icon: Icons.default.ProtraitOutlined },
    { id: "menuitem-faq", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/student\/tutorials-and-manuals)\/?$/], label: "Quick Guides: Demos & Manuals", children: null, link: `/student/tutorials-and-manuals`, activeIcon: Icons.default.LiveHelpIcon, icon: Icons.default.LiveHelpIconOutlined },
    { id: "menuitem-support", view: ["left-panel", "opened-bottom-bar"], secondaryIcon: Icons.default.OpenInNewIcon, activeMatchRegexes: [], target: "_blank", permission: true, label: "Support", children: null, link: ALIVE_SUPPORT_URL, icon: Icons.default.SupportAgentOutlined, activeIcon: Icons.default.SupportAgent },
    { id: 'menuitem-erp', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [], permission: true, label: "ERP", children: null, link: ERPDashboardPageURL, icon: Icons.default.Logout, activeIcon: Icons.default.Logout },
]

const SidedrawerMenuItem = ( { item, isActive, sidebarOpenState, closeOnMobileScreen, active } ) => {

    const [collapseState, setCollapseState] = useState( false )
    const { palette } = useTheme()

    return <Box borderRadius="5px" bgcolor={collapseState && palette.nav.sidebarHover}>
        <Link className='default-link' target={item.target} to={!item.children ? typeof item.link === 'string' ? item.link : item.link() : `#${item.label}`}>
            <Box
                onClick={item.children ? () => setCollapseState( !collapseState ) : closeOnMobileScreen}
                color={palette.nav.font}
                borderRadius="5px"
                sx={{
                    cursor: "pointer",
                    position: "relative",
                    background: collapseState ? isActive ? palette.nav.activeSidebarItem : palette.nav.activeSidebarItem + "80" : isActive ? palette.nav.activeSidebarItem : "none",
                    "&:hover": {
                        background: !isActive ? palette.nav.activeSidebarItem + 80 : palette.nav.activeSidebarItem,
                    }
                }}
                display="flex"
                alignItems="center"
                padding="5px"
                gap="15px"
                marginY="5px"
                minWidth={closedSidebarWidth - 20}
            >
                <IconButton
                    color="inherit"
                    disableFocusRipple
                    disableRipple
                    disableTouchRipple
                    sx={{
                        padding: "2px",
                        borderRadius: "5px",
                        transform: "scale(0.9)",
                        position: "relative",
                        fontSize: "18px"
                    }}>
                    {isActive ? item.icon : item.icon}
                </IconButton>
                <Box flexGrow={1} gap="5px" justifyContent="space-between" display="flex" alignItems="center" flexShrink={0} color="inherit" fontWeight={isActive ? "500" : "300"} fontSize="14px" textAlign="center">
                    <Typography display="flex" gap="5px" alignItems="center" fontWeight={isActive ? "500" : "400"} fontSize="14px" color="inherit">
                        {item.label}
                        {item.new && <Typography component="span" sx={{ fontSize: "8px", background: `linear-gradient(125.39deg, #139CFF -32.54%, #C54097 110.4%)`, padding: "3px 3px", top: "12px", right: "-15px", borderRadius: "5px" }} >NEW</Typography>}
                    </Typography>
                    <Box component="span" color={palette.text.secondary}>{item.children ? Icons.small.KeyboardArrowDown : item.secondaryIcon || ""}</Box>
                </Box>
            </Box>
        </Link>
        {item.children && <Collapse in={collapseState}>
            <Box flexDirection="column" paddingBottom="10px" display="flex" gap="5px" paddingRight="20px" paddingLeft="30px">
                {item.children.map( ( sublink, index ) => {
                    const activeChild = item.activeMatchRegexes[index].some( re => active.match( re ) )
                    return <Link className='default-link' key={sublink} to={item.link[index]}>
                        <Box
                            display="flex"
                            onClick={closeOnMobileScreen}
                            borderRadius="5px"
                            padding="2px 5px"
                            gap="20px"
                            alignItems="center"
                            sx={{
                                color: activeChild ? "white" : "lightgrey",
                                cursor: "pointer",
                                position: "relative",

                                "&::before": {
                                    display: activeChild ? "inline-block" : "none",
                                    content: "''",
                                    position: "absolute",
                                    background: "#fff",
                                    height: "60%",
                                    borderRadius: "0 2px 2px 0",
                                    left: 0,
                                    width: "2px",
                                    zIndex: 324434,
                                    top: "50%",
                                    transform: "translate(0,-50%)"
                                },

                                "&:hover": {
                                    textDecoration: "underline",
                                }
                            }}
                        >
                            <Typography variant="subtitle2" flexShrink={0} color="inherit" fontWeight={activeChild ? "500" : "400"} fontSize="14px" textAlign="center">{sublink}</Typography>
                        </Box>
                    </Link>
                } )}
            </Box>
        </Collapse>}
    </Box>
}

const SideDrawer = function ( { closeSideMenu } ) {
    const { sidebarOpenState, setNavHeadText, active, menuState, setMenuState, sidebarWidth, minSidebarCollapseWidth } = useLayoutContext()

    const { palette } = useTheme()

    const closeOnMobileScreen = () => {
        if ( window.innerWidth < minSidebarCollapseWidth )
            closeSideMenu()
    }


    useEffect( () => {
        for ( let i = 0; i < menu.length; i++ ) {
            const item = menu[i]
            const isActive = item.activeMatchRegexes.flat().some( re => active.match( re ) )
            if ( isActive ) {
                setNavHeadText( item.label )
                break
            }
        }
    }, [active, setNavHeadText] )


    return (
        <Box>
            <Box display={{ sm: "block", xs: "none" }}>
                <Drawer
                    variant='persistent'
                    sx={{ background: "transparent", position: "initial", overflow: "hidden", width: menuState ? sidebarWidth : 0, height: "100%", flexSrink: 0, display: { sm: "flex", xs: "none" }, flexDirection: "column" }}
                    anchor="left"
                    open={menuState}
                    className="no-scrollbar"
                    slotProps={{
                        paper: { className: "no-scrollbar", sx: { width: sidebarWidth, borderRadius: "0", background: palette.layoutBackground, borderRight: "none" } }
                    }}
                >
                    <Box position="relative" flexGrow={1} overflow="auto" display="flex">
                        <Box className="sidebar-scrollbar" display="flex" flexDirection="column" width="100%" overflow="auto" color="GrayText" alignItems="stretch">
                            <Box display="flex" gap="10px" padding="20px 10px" alignItems="center">
                                <Box padding="5px 7px" display="flex" alignItems="center" justifyContent="center" borderRadius="5px" sx={{ aspectRatio: "1 / 1" }} bgcolor="white"><Box component="img" width="20px" src={aliveLogo} alt="Logo" /></Box>
                                <Box>
                                    <Typography color="white" fontSize="14px" variant='h6'>Alive</Typography>
                                    <Typography color="white" fontSize="12px" fontWeight="300" variant='body2'>Acharya LMS platform</Typography>
                                </Box>
                                <IconButton sx={{ color: "white", display: { sm: "none", xs: "block" } }} onClick={() => setMenuState( false )}>
                                    {Icons.default.CloseIcon}
                                </IconButton>
                            </Box>
                            <Box padding="0 10px 20px 10px" className="sidebar-scrollbar" flexGrow={1} overflow="auto">
                                {menu.map( item => {
                                    const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                    return (
                                        <SidedrawerMenuItem active={active} closeOnMobileScreen={closeOnMobileScreen} item={item} isActive={isActive} sidebarOpenState={sidebarOpenState} key={item.id} />
                                    )
                                } )}
                            </Box>
                        </Box>
                    </Box >
                </Drawer >
            </Box>
            <Box display={{ sm: "none", xs: "block" }}>
                <Box display="flex" gap="20px" sx={{ background: `linear-gradient(90deg, rgb(3, 0, 52) 25.54%, rgb(10, 0, 154) 205.66%)` }} alignItems="center" justifyContent="space-evenly" padding="10px 20px">
                    {menu.filter( item => item.view.includes( "bleeding-bottom-bar" ) ).map( item => {
                        const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                        return (
                            <Box key={item.id}>
                                <Link to={item.link} className='default-link' >
                                    <Box color={isActive ? palette.nav.activeSidebarItem : "white"} display="flex" alignItems="center" flexDirection="column" gap="5px">
                                        <Box fontSize="20px" display="flex" alignItems="center" justifyContent="center" >{item.icon}</Box>
                                        <Typography color={isActive ? palette.nav.activeSidebarItem : "white"} fontSize="12px" textAlign="center" >{item.label}</Typography>
                                    </Box>
                                </Link>
                            </Box>
                        )
                    } )}
                    <Box sx={{ cursor: "pointer" }} onClick={() => setMenuState( true )} color="white" display="flex" alignItems="center" flexDirection="column" gap="5px">
                        <Box fontSize="20px" display="flex" alignItems="center" justifyContent="center" >{Icons.default.Menu}</Box>
                        <Typography color="white" fontSize="12px" textAlign="center" >More</Typography>
                    </Box>
                </Box>
                <SwipeableDrawer
                    sx={{ background: "transparent", zIndex: { sm: "initial", xs: "120000" }, overflow: "hidden", width: menuState ? sidebarWidth : 0, flexSrink: 0, display: { xs: "flex", sm: "none" }, flexDirection: "column" }}
                    anchor="bottom"
                    open={menuState}
                    className="no-scrollbar"
                    keepMounted={false}
                    swipeAreaWidth={0}
                    onClose={() => setMenuState( false )}
                    onOpen={() => setMenuState( true )}
                    slotProps={{
                        paper: { className: "no-scrollbar", sx: { borderRadius: "10px 10px 0 0", background: `linear-gradient(90deg, rgb(3, 0, 52) 25.54%, rgb(10, 0, 154) 205.66%)`, borderRight: "none" } }
                    }}
                >
                    <Box position="relative" flexGrow={1} overflow="auto" display="flex">
                        <Box className="sidebar-scrollbar" display="grid" gridTemplateColumns="repeat(3,1fr)" padding="40px 20px" flexWrap="wrap" width="100%" gap="30px" justifyContent="space-evenly" overflow="auto" color="GrayText" alignItems="stretch">
                            {menu.filter( item => item.view.includes( "opened-bottom-bar" ) ).map( item => {
                                const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                return (
                                    <Box key={item.id}>
                                        <Link to={item.link} className='default-link' >
                                            <Box color={isActive ? palette.nav.activeSidebarItem : "white"} display="flex" alignItems="center" flexDirection="column" gap="5px">
                                                <Box fontSize="20px" display="flex" alignItems="center" justifyContent="center" >{item.icon}</Box>
                                                <Typography color={isActive ? palette.nav.activeSidebarItem : "white"} fontSize="12px" textAlign="center" >{item.label}</Typography>
                                            </Box>
                                        </Link>
                                    </Box>
                                )
                            } )}
                        </Box>
                    </Box >
                </SwipeableDrawer >
            </Box>
        </Box >
    )
}

export default SideDrawer

